import React from 'react';
import { connectWS, getFormData } from '../../common';
import { QuizShowRepository } from '../../repository/QuizShowRepository';

const repository = new QuizShowRepository();
const getAccountId = () => window.localStorage.getItem("quiz-show-account-id");
const removeAccountId = () => window.localStorage.removeItem("quiz-show-account-id")

class QuizShowGamePlayPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {},
      connected: false,
      quiz: {}
    };

    this.sock = undefined;
  }

  componentDidMount() {
    const accountId = getAccountId();
    if (!accountId) {
      this.props.history.push("/quizshow");
      return;
    }

    repository.findMe({ accountId }, (data) => this.setState({ user: data }), () => {
      removeAccountId();
      setTimeout(() => {
        window.location.reload();
      }, 100);
    });

    return () => {
      this.sock && this.sock.close();
    };
  }

  onMessageHandler(msg) {
    const data = JSON.parse(msg.data);
    const payload = data.payload;

    switch (data.messageType) {
      case "QUIZ_EXAM_START":
        this.setState({ quiz: payload });
        break;
      case "QUIZ_EXAM_END":
        this.setState({ quiz: {} });
        break;
      default:
        break;
    }
  }

  render() {
    const { gameId } = this.props.match.params;
    const { user, quiz, connected } = this.state;
    const accountId = getAccountId();

    const onClickConnect = (e) => {
      e.preventDefault();
      repository.joinGame({ gameId, accountId }, () => {
        this.sock = connectWS(accountId,
          () => {
            this.setState({ connected: true });
            window.Toast.info("접속 완료!");
          },
          () => this.setState({ connected: false }),
          this.onMessageHandler.bind(this));
      });
    };

    const onSubmitAnswer = (answer) => {
      repository.solveQuiz({ quizId: quiz.quizId, answer, accountId }, () => {
        this.setState({ quiz: {} });
        window.Toast.info("제출 완료!");
      });
    };

    return (
      <>
        <div style={{ flex: 1, display: "flex", flexDirection: "column", position: "absolute", left: 0, right: 0, top: 0, bottom: 0 }}>
          <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center" }}>
            <div>
              {user && user.id && (<div style={{ fontSize: 28 }}>welcome! <b>{user.nickname}</b>님</div>)}
            </div>
            {!connected && (
              <div style={{ marginTop: 10 }}>
                <button className={"btn btn-lg btn-primary"} style={{ width: 200 }} onClick={onClickConnect}>접속</button>
              </div>
            )}
          </div>

          <div style={{ flex: 3, background: "#eee" }}>
            {quiz && quiz.quizId && (
              <div className={"container"} style={{ marginTop: 20 }}>
                <AnswerSheet quiz={quiz} onSubmitAnswer={onSubmitAnswer} />
              </div>
            )}
          </div>
        </div>

        {connected && (<ConnectBar />)}
      </>
    );
  }
}

const ConnectBar = () => {
  return (
    <div className={"twinkle"} style={{ position: "absolute", top: 0, left: 0, right: 0, height: 10, background: "#82b1ff" }}></div>
  );
};

const AnswerSheet = (props) => {
  const { quiz } = props;
  const objective = (quiz.exams || []).length > 1;

  const onClickAnswer = (e) => {
    e.preventDefault();
    const { answer } = e.target.dataset;
    props.onSubmitAnswer && props.onSubmitAnswer(answer);
  };

  const onEnterAnswer = (e) => {
    e.preventDefault();
    const formData = getFormData(e.target);
    const { answer } = formData;
    if (!answer) {
      window.Toast.danger("답을 입력하세요!");
      return;
    }

    props.onSubmitAnswer && props.onSubmitAnswer(answer);
  };

  const btnCls = ["btn-danger", "btn-info", "btn-primary", "btn-success"];

  return (
    <div>
      {objective && (
        <div className={"row"}>
          {quiz.exams.map((item, idx) => (
            <div className={"col-6"} style={{ padding: 10 }} key={idx}>
              <button
                className={`btn ${btnCls[idx % (btnCls.length)]}`}
                style={{ width: "100%", fontSize: 32, padding: 16 }}
                onClick={onClickAnswer} data-answer={item}>{item}</button>
            </div>
          ))}
        </div>
      )}
      {!objective && (
        <form onSubmit={onEnterAnswer}>
          <div className={"form-group"}>
            <input className={"form-control"} name={"answer"} style={{ fontSize: 24 }} autoComplete={"off"} />
            <br />
            <button className={"btn btn-primary"} type={"submit"} style={{ width: "100%", fontSize: 24 }}>제출</button>
          </div>
        </form>
      )}
    </div>
  );
};

export { QuizShowGamePlayPage };
